import { render, staticRenderFns } from "./ResultInaugural.vue?vue&type=template&id=bd5a5b10&scoped=true&"
import script from "./ResultInaugural.vue?vue&type=script&lang=js&"
export * from "./ResultInaugural.vue?vue&type=script&lang=js&"
import style0 from "./ResultInaugural.vue?vue&type=style&index=0&id=bd5a5b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5a5b10",
  null
  
)

export default component.exports